import { MatchPlayerDetail } from '@/models/matchPlayerDetail.model'
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
})
export default class PlayerEvents extends Vue {
  @Prop({ required: true }) playerDetail!: MatchPlayerDetail;

}